var map = {
	"./de-DE.json": "./src/locales/de-DE.json",
	"./en-GB.json": "./src/locales/en-GB.json"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/locales lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;